import React, { useContext } from 'react'
import { NavigationContext } from '../context/NavigationContext'
import { Link } from 'react-router-dom'
import Icon from '../res/icons'
import pdf from '../files/nf05_informations_generales.pdf'

const Button = (props) => {
    const { icon, to, align, type } = props
    if (type == "intern") {
        return (
            <Link to={to} >
                <div className={`button ${align} intern`}>
                    <div className="button-title">
                        {props.children}
                    </div>
                </div>
            </Link>
        )
    }
    if (type == "extern") {
        return (
            <a href={to} target="_blank" >
                <div className={`button ${align} intern`}>
                    <div className="button-title">
                        {props.children}
                    </div>
                </div>
            </a>
        )
    }
    if (type == "download") {
        return (
            <a href={pdf} target="_blank" >
                <div className={`button ${align} download`}>
                    <div className="button-title">
                        {props.children}
                    </div>
                    <div className="button-icon">
                        {icon != '' && <Icon name='download' height={'24px'} fill={'white'} />}
                    </div>
                </div>
            </a>
        )
    }
    if (icon == "arrow-left") {
        return (
            <Link to={to} >
                <div className={`button ${align}`}>
                    <div className="button-icon-left">
                        {icon != '' && <Icon name={icon} height={'24px'} fill={'white'} />}
                    </div>
                    <div className="button-title-left">
                        {props.children}
                    </div>
                </div>
            </Link>
        );
    }
    return (
        <Link to={to} >
            <div className={`button ${align}`}>
                <div className="button-title">
                    {props.children}
                </div>
                <div className="button-icon">
                    {icon != '' && <Icon name={icon} height={'24px'} fill={'white'} />}
                </div>
            </div>
        </Link>
    );
}

export default Button;